//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'serviceRequests',
  data: function data() {
    return {
      title: 'Service Requests',
      headers: ['Date Opened', 'Priority', 'Description', 'Status', 'Assigned To'],
      fields: ['created_at', 'priority_text', 'description', 'status', 'assignee.full_name'],
      serviceRequests: []
    };
  },

  methods: {
    openFullModal: function openFullModal(_ref) {
      var serviceRequests = _ref.serviceRequests,
          title = _ref.title;

      Object.assign(this, { serviceRequests: serviceRequests, title: title });
      this.$children[0].$data.showModal = true;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/dashboard/PropertyServiceRequests.vue
// module id = 3vnq
// module chunks = 0 1